import React, { useEffect, useState, useContext } from "react";
import Axios from "axios";
import AxiosInstance from "../AxiosInstance";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { namedaysHU } from "../Data/namedays";
import {
  Button,
  Typography,
  AppBar,
  Toolbar,
  Menu,
  MenuItem,
  Snackbar,
  Tooltip,
  ThemeProvider,
  responsiveFontSizes,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Collapse,
  Divider,
} from "@mui/material";
import { createTheme } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StateContext from "../Contexts/StateContext";
import DispatchContext from "../Contexts/DispatchContext";
import logo from "../Assets/populiathyleregis.png";
import AddLocationIcon from "@mui/icons-material/AddLocationAlt";
import MapIcon from "@mui/icons-material/Map";
import YouTubeIcon from "@mui/icons-material/YouTube";
import EventIcon from '@mui/icons-material/Event';
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import config, { environment } from '../config';

let theme = createTheme();
theme = responsiveFontSizes(theme);

function Header() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const routerLocation = useLocation();
  const GlobalState = useContext(StateContext);
  const GlobalDispatch = useContext(DispatchContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));

  // -------------------- Menu States --------------------
  const [anchorEl, setAnchorEl] = useState(null);
  const [mapAnchorEl, setMapAnchorEl] = useState(null);
  const [marketAnchorEl, setMarketAnchorEl] = useState(null);
  const [marketMenuAnchorEl, setMarketMenuAnchorEl] = useState(null);
  const [accommodationAnchorEl, setAccommodationAnchorEl] = useState(null);
  const [companiesMastersAnchorEl, setCompaniesMastersAnchorEl] = useState(null);
  const [sightsAnchorEl, setSightsAnchorEl] = useState(null);
  const [institutionsAnchorEl, setInstitutionsAnchorEl] = useState(null);
  const [familyAnchorEl, setFamilyAnchorEl] = useState(null);
  const [addObjectsAnchorEl, setAddObjectsAnchorEl] = useState(null);
  const [thematicMapsAnchorEl, setThematicMapsAnchorEl] = useState(null);
  const [openSnack, setOpenSnack] = useState(false);

  const [exchangeRates, setExchangeRates] = useState({});
  const [currencyAnchorEl, setCurrencyAnchorEl] = useState(null);
  const currencyMenuOpen = Boolean(currencyAnchorEl);
  const [namedays, setNamedays] = useState({ catholic: "", reformed: "", unitarian: "" });

  // Mobile Drawer states
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [mobileSightsOpen, setMobileSightsOpen] = useState(false);
  const [mobileCompaniesOpen, setMobileCompaniesOpen] = useState(false);
  const [mobileAccommodationOpen, setMobileAccommodationOpen] = useState(false);
  const [mobileFamilyOpen, setMobileFamilyOpen] = useState(false);
  const [mobileAddObjectsOpen, setMobileAddObjectsOpen] = useState(false);
  const [mobileThematicMapsOpen, setMobileThematicMapsOpen] = useState(false);

  const open = Boolean(anchorEl);
  const mapOpen = Boolean(mapAnchorEl);
  const marketOpen = Boolean(marketAnchorEl);
  const marketMenuOpen = Boolean(marketMenuAnchorEl);
  const accommodationOpen = Boolean(accommodationAnchorEl);
  const companiesMastersOpen = Boolean(companiesMastersAnchorEl);
  const sightsOpen = Boolean(sightsAnchorEl);
  const institutionsOpen = Boolean(institutionsAnchorEl);
  const familyOpen = Boolean(familyAnchorEl);
  const addObjectsOpen = Boolean(addObjectsAnchorEl);
  const thematicMapsOpen = Boolean(thematicMapsAnchorEl);

  // -------------------- Menu Handlers --------------------
  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  const handleClick = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleMapClick = (e) => setMapAnchorEl(e.currentTarget);
  const handleMapClose = () => setMapAnchorEl(null);

  const handleMarketClick = (e) => setMarketAnchorEl(e.currentTarget);
  const handleMarketClose = () => setMarketAnchorEl(null);

  const handleMarketMenuClick = (e) => setMarketMenuAnchorEl(e.currentTarget);
  const handleMarketMenuClose = () => setMarketMenuAnchorEl(null);

  const handleAccommodationClick = (e) => setAccommodationAnchorEl(e.currentTarget);
  const handleAccommodationClose = () => setAccommodationAnchorEl(null);

  const handleCompaniesMastersClick = (e) => setCompaniesMastersAnchorEl(e.currentTarget);
  const handleCompaniesMastersClose = () => setCompaniesMastersAnchorEl(null);

  const handleSightsClick = (e) => setSightsAnchorEl(e.currentTarget);
  const handleSightsClose = () => setSightsAnchorEl(null);

  const handleInstitutionsClick = (e) => setInstitutionsAnchorEl(e.currentTarget);
  const handleInstitutionsClose = () => setInstitutionsAnchorEl(null);

  const handleFamilyClick = (e) => setFamilyAnchorEl(e.currentTarget);
  const handleFamilyClose = () => setFamilyAnchorEl(null);

  const handleAddObjectsClick = (e) => setAddObjectsAnchorEl(e.currentTarget);
  const handleAddObjectsClose = () => setAddObjectsAnchorEl(null);

  const handleThematicMapsClick = (e) => setThematicMapsAnchorEl(e.currentTarget);
  const handleThematicMapsClose = () => setThematicMapsAnchorEl(null);

  const handleCurrencyClick = (e) => setCurrencyAnchorEl(e.currentTarget);
  const handleCurrencyClose = () => setCurrencyAnchorEl(null);

  // -------------------- Logout --------------------
  const handleLogout = async () => {
    handleClose();
    if (!window.confirm(t('Header.LogoutConfirm', 'Biztosan ki szeretne jelentkezni?'))) return;

    try {
      if (GlobalState.jwtAccessToken && config[environment].logoutEndpoint) {
        await AxiosInstance.post(
            config[environment].logoutEndpoint,
            {}
        );
      }
    } catch (e) {
    } finally {
      GlobalDispatch({ type: "logout" });
      setOpenSnack(true);
      navigate(`/${i18n.language.split('-')[0]}/`);
    }
  };

  // -------------------- Profile / Account --------------------
  const cleanLang = i18n.language.split('-')[0];
  const handleProfile = () => { handleClose(); navigate(`/${cleanLang}/profile`); };
  const handleAccount = () => { handleClose(); navigate(`/${cleanLang}/account`); };

  // -------------------- Map Submenus --------------------
  const handleTouristicObjects = () => { handleMapClose(); navigate(`/${cleanLang}/touristicobjects`); };
  const handleGeologicalObjects = () => { handleMapClose(); navigate(`/${cleanLang}/geologicalobjects`); };
  const handleFlora = () => { handleMapClose(); navigate(`/${cleanLang}/flora`); };
  const handleMonuments = () => { handleMapClose(); navigate(`/${cleanLang}/monuments`); };
  const handleMineralWaters = () => { handleMapClose(); navigate(`/${cleanLang}/mineralwaters`); };

  // -------------------- Public Route Protection --------------------
  useEffect(() => {
    const fetchExchangeRates = async () => {
      try {
        const res = await Axios.get("https://www.floatrates.com/daily/ron.json");
        const data = res.data;
        const rates = {};

        if (data.huf) rates.huf = (1 / data.huf.rate).toFixed(2);
        if (data.eur) rates.eur = (1 / data.eur.rate).toFixed(4);
        if (data.usd) rates.usd = (1 / data.usd.rate).toFixed(4);
        if (data.gbp) rates.gbp = (1 / data.gbp.rate).toFixed(4);
        if (data.chf) rates.chf = (1 / data.chf.rate).toFixed(4);

        setExchangeRates(rates);
        GlobalDispatch({ type: "setExchangeRates", rates: rates });
      } catch (err) {
        console.error("Exchange rates fetch failed:", err);
        setExchangeRates({ error: true });
        GlobalDispatch({ type: "setExchangeRates", rates: { error: true } });
      }
    };

    const fetchNamedays = () => {
      const now = new Date();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const key = `${month}-${day}`;
      if (namedaysHU && namedaysHU[key]) {
        setNamedays(namedaysHU[key]);
      }
    };

    fetchExchangeRates();
    fetchNamedays();
  }, []);

  useEffect(() => {
    const publicPaths = [
      "/", "/login", "/register", "/created", "/activation",
      "/password-reset", "/password-reset/",
      "/terkep", "/market", "/news", "/kutfok", "/academy",
      "/epitett-orokseg", "/novenyvilag", "/neprajzi", "/rovasemlek",
      "/gyalogtura", "/lovastura", "/egyhazi",
      "/institutions", "/cegek", "/mesterek", "/napszamosok",
      "/impresszum", "/privacy-policy", "/mobile-privacy-policy", "/sutibeallitasok",
    ];

    const pathname = routerLocation.pathname.replace(/^\/[a-z]{2}/, "");
    const isPublic = publicPaths.some(p => pathname === p || pathname.startsWith(p + "/"));

  }, [GlobalState.userIsLogged, routerLocation.pathname, navigate]);

  const changeLanguage = (lng) => {
    const currentPath = routerLocation.pathname;
    const pathParts = currentPath.split('/').filter(part => part !== "");
    const supportedLanguages = ['hu', 'en', 'ro', 'de', 'fr', 'es', 'it'];
    
    // Ensure we use the 2-letter code if a longer one is provided
    const cleanLng = lng.split('-')[0].toLowerCase();
    
    let newPath;
    if (pathParts.length > 0 && supportedLanguages.includes(pathParts[0])) {
      // Replace existing lang prefix
      pathParts[0] = cleanLng;
      newPath = '/' + pathParts.join('/');
    } else {
      // Add new lang prefix
      newPath = `/${cleanLng}${currentPath === '/' ? '' : currentPath}`;
    }
    
    i18n.changeLanguage(cleanLng);
    navigate(newPath);
  };

  const languageButtons = (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: isMobile ? "center" : "space-between",
          alignItems: "center",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          py: 0.2,
          px: 2,
          flexWrap: isMobile ? "wrap" : "nowrap",
          overflowX: isMobile ? "visible" : "auto",
          "&::-webkit-scrollbar": { display: "none" },
          msOverflowStyle: "none",
          scrollbarWidth: "none"
        }}
      >
        {/* 1 RON értéke: Exchange Rates List (Left) */}
        {isMobile ? (
          <Box sx={{ display: "flex", alignItems: "center", flex: "0 0 auto" }}>
            <Button
              size="small"
              onClick={handleCurrencyClick}
              sx={{
                color: "rgba(255, 255, 255, 0.9)",
                fontSize: "0.65rem",
                fontWeight: "bold",
                textTransform: "none",
                minWidth: "auto",
                "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" }
              }}
            >
              {t('Header.RONValuePrefix', '1 RON értéke ≈ ').split('≈')[0]}
              <span style={{ fontSize: '1rem', marginLeft: '4px', marginRight: '2px', lineHeight: 0 }}>≈</span>
              <ExpandMore sx={{ fontSize: "0.8rem", ml: 0.5 }} />
            </Button>
            <Menu
              anchorEl={currencyAnchorEl}
              open={currencyMenuOpen}
              onClose={handleCurrencyClose}
              PaperProps={{
                sx: {
                  backgroundColor: "rgba(0, 0, 0, 0.85)",
                  backdropFilter: "blur(5px)",
                  color: "white",
                  minWidth: "120px"
                }
              }}
            >
              {exchangeRates && Object.keys(exchangeRates).length > 0 ? (
                exchangeRates.error ? (
                  <MenuItem disabled sx={{ fontSize: "0.65rem" }}>
                    {t('Header.ExchangeRatesUnavailable', 'Árfolyamok nem elérhetőek')}
                  </MenuItem>
                ) : (
                  ["huf", "eur", "usd", "gbp", "chf"].map((currency) => (
                    exchangeRates[currency] && (
                      <MenuItem key={currency} onClick={handleCurrencyClose} sx={{ fontSize: "0.65rem", py: 0.5 }}>
                        {exchangeRates[currency]} {currency.toUpperCase()}
                      </MenuItem>
                    )
                  ))
                )
              ) : (
                <MenuItem disabled sx={{ fontSize: "0.65rem" }}>
                  {t('Common.Loading', 'Betöltés...')}
                </MenuItem>
              )}
            </Menu>
          </Box>
        ) : (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flex: "0 0 auto", flexWrap: isMobile ? "wrap" : "nowrap", justifyContent: isMobile ? "center" : "flex-start" }}>
            <Typography sx={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "0.65rem", fontWeight: "bold", display: "flex", alignItems: "center", whiteSpace: "nowrap" }}>
              {t('Header.RONValuePrefix', '1 RON értéke ≈ ').split('≈')[0]}
              <span style={{ fontSize: '1rem', marginLeft: '2px', marginRight: '2px', lineHeight: 0 }}>≈</span>
            </Typography>

            {exchangeRates && Object.keys(exchangeRates).length > 0 ? (
              exchangeRates.error ? (
                <Typography sx={{ color: "rgba(255, 255, 255, 0.5)", fontSize: "0.65rem", fontStyle: "italic" }}>
                  {t('Header.ExchangeRatesUnavailable', 'Árfolyamok nem elérhetőek')}
                </Typography>
              ) : (
                <>
                  {exchangeRates.huf && (
                    <Typography sx={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "0.65rem", whiteSpace: "nowrap" }}>
                      {exchangeRates.huf} HUF
                    </Typography>
                  )}
                  {exchangeRates.eur && (
                    <Typography sx={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "0.65rem", whiteSpace: "nowrap" }}>
                      {exchangeRates.eur} EUR
                    </Typography>
                  )}
                  {exchangeRates.usd && (
                    <Typography sx={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "0.65rem", whiteSpace: "nowrap" }}>
                      {exchangeRates.usd} USD
                    </Typography>
                  )}
                  {exchangeRates.gbp && (
                    <Typography sx={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "0.65rem", whiteSpace: "nowrap" }}>
                      {exchangeRates.gbp} GBP
                    </Typography>
                  )}
                  {exchangeRates.chf && (
                    <Typography sx={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "0.65rem", whiteSpace: "nowrap" }}>
                      {exchangeRates.chf} CHF
                    </Typography>
                  )}
                </>
              )
            ) : (
               <Typography sx={{ color: "rgba(255, 255, 255, 0.5)", fontSize: "0.65rem", fontStyle: "italic" }}>
                 {t('Common.Loading', 'Betöltés...')}
               </Typography>
            )}
          </Box>
        )}

        {/* Namedays (Center) */}
        <Box sx={{ display: { xs: "none", md: "flex" }, gap: 1, alignItems: "center", flex: "1 1 auto", justifyContent: "center", minWidth: 0 }}>
          {(namedays.catholic || namedays.reformed || namedays.unitarian) && (
            <Typography sx={{ color: "rgba(255, 255, 255, 0.8)", fontSize: "0.65rem", textAlign: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              <span style={{ fontWeight: 'bold' }}>{t('Header.TodayWeGreet')}</span>
              {(() => {
                const names = [];
                if (namedays.catholic) names.push(...namedays.catholic.split(',').map(n => n.trim()));
                if (namedays.reformed) names.push(...namedays.reformed.split(',').map(n => n.trim()));
                if (namedays.unitarian) names.push(...namedays.unitarian.split(',').map(n => n.trim()));
                const uniqueNames = [...new Set(names)];
                return uniqueNames.join(', ');
              })()}
            </Typography>
          )}
          <Tooltip title={t('Header.SzeklerlandEventCalendar', 'Székelyföldi eseménynaptár')}>
            <IconButton
              size="small"
              color="inherit"
              onClick={() => navigate(`/${i18n.language.split('-')[0]}/szekelyfoldi-esemenyek`)}
              sx={{ p: 0.5, color: "rgba(255, 255, 255, 0.8)" }}
            >
              <EventIcon sx={{ fontSize: "1rem" }} />
            </IconButton>
          </Tooltip>
        </Box>

        {/* Language selector (Right) */}
        <Box sx={{ display: "flex", flex: "0 0 auto", justifyContent: isMobile ? "center" : "flex-end", width: isMobile ? "100%" : "auto" }}>
          {["hu", "ro", "en", "de", "fr", "es", "it"].map((lng) => (
            <Button
              key={lng}
              size="small"
              onClick={() => changeLanguage(lng)}
              sx={{
                minWidth: "auto",
                px: 1,
                py: 0,
                fontSize: "0.7rem",
                color: i18n.language && i18n.language.startsWith(lng) ? "#fff" : "rgba(255, 255, 255, 0.6)",
                fontWeight: i18n.language && i18n.language.startsWith(lng) ? "bold" : "normal",
                textTransform: "lowercase",
                "&:hover": {
                  color: "#fff",
                },
              }}
            >
              {lng}
            </Button>
          ))}
        </Box>
      </Box>

      {/* Thematic Submenu (New row - desktop only) */}
      {!isMobile && (
        <Box sx={{
          display: "flex",
          alignItems: "stretch",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
          borderTop: "1px solid rgba(255, 255, 255, 0.05)",
        }}>
          {/* Label with red background and slanted edge */}
          <Box sx={{
            backgroundColor: "#d32f2f",
            color: "white",
            px: 2,
            py: 0.3,
            fontSize: "0.65rem",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            position: "relative",
            mr: 2,
            '&:after': {
              content: '""',
              position: 'absolute',
              top: 0,
              right: -10,
              width: 0,
              height: 0,
              borderLeft: '10px solid #d32f2f',
              borderBottom: '22px solid transparent', // Adjust based on height
            }
          }}>
            {t('Header.ThematicMaps', 'TEMATIKUS TÉRKÉPEK')}
          </Box>

          {/* Links */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {[
              { label: t('Thematic.TouristRoutes'), path: '/turista-utvonalak' },
              { label: t('Thematic.GeologicalMap'), path: '/foldtani-terkep' },
              { label: t('Thematic.FolkCostume'), path: '/nepviselet-terkep' },
              { label: t('Thematic.FolkArchitecture'), path: '/nepi-epiteszet-terkep' },
              { label: t('Thematic.Szekelykapu'), path: '/szekelykapu-terkep' },
              { label: t('Thematic.Pantheon'), path: '/panteon-terkep' },
              { label: t('Thematic.Futuristique'), path: '/futuristique-terkep' },
              { label: t('Thematic.Ballada'), path: '/ballada-terkep' },
              { label: t('Thematic.Nepdal'), path: '/nepdal-terkep' },
              { label: t('Thematic.Locsoloversek'), path: '/locsoloversek-terkep' },
            ].map((item, index, arr) => (
              <React.Fragment key={item.path}>
                <Button
                  size="small"
                  onClick={() => navigate(`/${i18n.language.split('-')[0]}${item.path}`)}
                  sx={{
                    color: "rgba(255, 255, 255, 0.8)",
                    fontSize: "0.65rem",
                    minWidth: "auto",
                    p: 0,
                    "&:hover": { color: "#fff", backgroundColor: "transparent" }
                  }}
                >
                  {item.label}
                </Button>
                {index < arr.length - 1 && (
                  <Typography sx={{ color: "rgba(255, 255, 255, 0.3)", fontSize: "0.65rem" }}>|</Typography>
                )}
              </React.Fragment>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );

  return (
    <AppBar position="fixed" sx={{ backgroundColor: "#0a4056", zIndex: 1200 }}>
      {languageButtons}
      <ThemeProvider theme={theme}>
        <Toolbar sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: { xs: 1, sm: 2 }
        }}>

          {isMobile ? (
            <>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={toggleDrawer(true)}
                  sx={{ mr: 1 }}
                >
                  <MenuIcon />
                </IconButton>
                <Box 
                  sx={{ display: "flex", alignItems: "center", cursor: "pointer" }} 
                  onClick={() => navigate(`/${i18n.language}`)}
                >
                  <img src={logo} style={{ width: "2.2rem", marginRight: "0.4rem" }} alt="Logo" />
                  <Tooltip title="@Zandírhám">
                    <IconButton color="inherit" component="a" href="https://www.youtube.com/@Zandírhám" target="_blank" rel="noopener noreferrer" sx={{ p: 0.5, mr: 0.5 }}>
                      <YouTubeIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', lineHeight: 1.1, fontSize: '0.85rem' }}>
                    SZNO
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                {GlobalState.userIsLogged && (
                  <Tooltip title={t('SubMenu.MapObject') + " +"}>
                    <IconButton color="inherit" onClick={() => navigate(`/${cleanLang}/add-map-object`)}>
                      <AddLocationIcon />
                    </IconButton>
                  </Tooltip>
                )}
                <Tooltip title={t('Header.InteractiveMap')}>
                  <IconButton color="inherit" onClick={() => navigate(`/${cleanLang}/terkep`)}>
                    <MapIcon />
                  </IconButton>
                </Tooltip>
                {!GlobalState.userIsLogged && (
                  <Button color="inherit" onClick={() => navigate(`/${cleanLang}/login`)} sx={{ fontSize: '0.8rem' }}>{t('Header.Login')}</Button>
                )}
                {GlobalState.userIsLogged && GlobalState.userUsername && (
                  <IconButton color="inherit" onClick={handleClick}>
                    <Box sx={{ width: 32, height: 32, borderRadius: '50%', bgcolor: 'secondary.main', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '0.8rem' }}>
                      {GlobalState.userUsername.charAt(0).toUpperCase()}
                    </Box>
                  </IconButton>
                )}
              </Box>

              <Drawer
                anchor="left"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
                PaperProps={{
                  sx: { width: '280px', backgroundColor: '#0a4056', color: 'white' }
                }}
              >
                <Box
                  sx={{ width: 280 }}
                  role="presentation"
                >
                  <List>
                    <ListItem disablePadding>
                      <ListItemButton onClick={() => { navigate(`/${i18n.language.split('-')[0]}/`); setDrawerOpen(false); }}>
                        <ListItemText primary={t('Header.Kezdolap')} />
                      </ListItemButton>
                    </ListItem>
                    <Divider sx={{ backgroundColor: 'rgba(255,255,255,0.1)' }} />

                    {/* Thematic Maps Collapsible */}
                    <ListItemButton onClick={() => setMobileThematicMapsOpen(!mobileThematicMapsOpen)} sx={{ bgcolor: 'rgba(211, 47, 47, 0.2)' }}>
                      <ListItemText primary={t('Header.ThematicMaps')} sx={{ '& .MuiTypography-root': { fontWeight: 'bold', color: '#ffcdd2' } }} />
                      {mobileThematicMapsOpen ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={mobileThematicMapsOpen} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding sx={{ pl: 4, bgcolor: 'rgba(0,0,0,0.1)' }}>
                        {[
                          { label: t('Thematic.TouristRoutes'), path: '/turista-utvonalak' },
                          { label: t('Thematic.GeologicalMap'), path: '/foldtani-terkep' },
                          { label: t('Thematic.FolkCostume'), path: '/nepviselet-terkep' },
                          { label: t('Thematic.FolkArchitecture'), path: '/nepi-epiteszet-terkep' },
                          { label: t('Thematic.Szekelykapu'), path: '/szekelykapu-terkep' },
                          { label: t('Thematic.Pantheon'), path: '/panteon-terkep' },
                          { label: t('Thematic.Futuristique'), path: '/futuristique-terkep' },
                          { label: t('Thematic.Ballada'), path: '/ballada-terkep' },
                          { label: t('Thematic.Nepdal'), path: '/nepdal-terkep' },
                          { label: t('Thematic.Locsoloversek'), path: '/locsoloversek-terkep' },
                        ].map((item) => (
                          <ListItemButton key={item.path} onClick={() => { navigate(`/${cleanLang}${item.path}`); setDrawerOpen(false); }}>
                            <ListItemText primary={item.label} />
                          </ListItemButton>
                        ))}
                      </List>
                    </Collapse>
                    
                    <Divider sx={{ backgroundColor: 'rgba(255,255,255,0.1)' }} />
                    
                    <ListItem disablePadding>
                      <ListItemButton onClick={() => { navigate(`/${i18n.language}/news`); setDrawerOpen(false); }}>
                        <ListItemText primary={t('Header.Szemle')} />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton component="a" href="https://szotar.szno.ro/map">
                        <ListItemText primary={t('Header.SzekelySzotar').toUpperCase()} />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton component={Link} to={`/${i18n.language}/kutfok`} onClick={() => setDrawerOpen(false)}>
                        <ListItemText primary={t('Header.Kutfok')} />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton component={Link} to={`/${i18n.language}/academy`} onClick={() => setDrawerOpen(false)}>
                        <ListItemText primary={t('Header.Akademia')} />
                      </ListItemButton>
                    </ListItem>

                    {/* Family Collapsible */}
                    <ListItemButton onClick={() => setMobileFamilyOpen(!mobileFamilyOpen)}>
                      <ListItemText primary={t('Header.Family')} />
                      {mobileFamilyOpen ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={mobileFamilyOpen} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding sx={{ pl: 4, bgcolor: 'rgba(0,0,0,0.1)' }}>
                        <ListItemButton component={Link} to={`/${i18n.language}/csaladfaallitas`} onClick={() => setDrawerOpen(false)}>
                          <ListItemText primary={t('Header.FamilyTree')} />
                        </ListItemButton>
                        <ListItemButton component={Link} to={`/${i18n.language}/family-manager`} onClick={() => setDrawerOpen(false)}>
                          <ListItemText primary={t('Header.FamilyManager')} />
                        </ListItemButton>
                      </List>
                    </Collapse>

                    <ListItem disablePadding>
                      <ListItemButton component={Link} to={`/${i18n.language}/institutions`} onClick={() => setDrawerOpen(false)}>
                        <ListItemText primary={t('Header.Institutions')} />
                      </ListItemButton>
                    </ListItem>

                    <ListItem disablePadding>
                      <ListItemButton component={Link} to={`/${i18n.language}/market`} onClick={() => setDrawerOpen(false)}>
                        <ListItemText primary={t('Header.Piacter')} />
                      </ListItemButton>
                    </ListItem>

                    <Divider sx={{ backgroundColor: 'rgba(255,255,255,0.1)' }} />

                    {/* Sights Collapsible */}
                    <ListItemButton onClick={() => setMobileSightsOpen(!mobileSightsOpen)}>
                      <ListItemText primary={t('Header.Latnivalok')} />
                      {mobileSightsOpen ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={mobileSightsOpen} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding sx={{ pl: 4, bgcolor: 'rgba(0,0,0,0.1)' }}>
                        <ListItemButton component={Link} to={`/${i18n.language}/epitett-orokseg`} onClick={() => setDrawerOpen(false)}>
                          <ListItemText primary={t('Header.BuiltHeritage')} />
                        </ListItemButton>
                        <ListItemButton component={Link} to={`/${i18n.language}/rovasemlek`} onClick={() => setDrawerOpen(false)}>
                          <ListItemText primary={t('Header.RunicScripts')} />
                        </ListItemButton>
                        <ListItemButton component={Link} to={`/${i18n.language}/neprajzi`} onClick={() => setDrawerOpen(false)}>
                          <ListItemText primary={t('Header.Ethnographic')} />
                        </ListItemButton>
                        <ListItemButton component={Link} to={`/${i18n.language}/egyhazi`} onClick={() => setDrawerOpen(false)}>
                          <ListItemText primary={t('Header.Spiritual')} />
                        </ListItemButton>
                        <ListItemButton component={Link} to={`/${i18n.language}/geological-sights`} onClick={() => setDrawerOpen(false)}>
                          <ListItemText primary={t('Header.Geological')} />
                        </ListItemButton>
                        <ListItemButton component={Link} to={`/${i18n.language}/novenyvilag`} onClick={() => setDrawerOpen(false)}>
                          <ListItemText primary={t('Header.Botanical')} />
                        </ListItemButton>
                        <ListItemButton component={Link} to={`/${i18n.language}/gyalogtura`} onClick={() => setDrawerOpen(false)}>
                          <ListItemText primary={t('Header.Tracking')} />
                        </ListItemButton>
                        <ListItemButton component={Link} to={`/${i18n.language}/lovastura`} onClick={() => setDrawerOpen(false)}>
                          <ListItemText primary={t('Header.Equestrian')} />
                        </ListItemButton>
                      </List>
                    </Collapse>

                    {/* Companies Collapsible */}
                    <ListItemButton onClick={() => setMobileCompaniesOpen(!mobileCompaniesOpen)}>
                      <ListItemText primary={t('Header.CegekMesterek')} />
                      {mobileCompaniesOpen ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={mobileCompaniesOpen} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding sx={{ pl: 4, bgcolor: 'rgba(0,0,0,0.1)' }}>
                        <ListItemButton component={Link} to={`/${i18n.language}/cegek`} onClick={() => setDrawerOpen(false)}>
                          <ListItemText primary={t('Header.Companies')} />
                        </ListItemButton>
                        <ListItemButton component={Link} to={`/${i18n.language}/mesterek`} onClick={() => setDrawerOpen(false)}>
                          <ListItemText primary={t('Header.Masters')} />
                        </ListItemButton>
                        <ListItemButton component={Link} to={`/${i18n.language}/napszamosok`} onClick={() => setDrawerOpen(false)}>
                          <ListItemText primary={t('Header.DayLabourers')} />
                        </ListItemButton>
                      </List>
                    </Collapse>

                    {/* Accommodation Collapsible */}
                    <ListItemButton onClick={() => setMobileAccommodationOpen(!mobileAccommodationOpen)}>
                      <ListItemText primary={t('Header.Szallas')} />
                      {mobileAccommodationOpen ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={mobileAccommodationOpen} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding sx={{ pl: 4, bgcolor: 'rgba(0,0,0,0.1)' }}>
                        <ListItemButton onClick={() => { navigate(`/${i18n.language}/accommodation-market`); setDrawerOpen(false); }}>
                          <ListItemText primary={t('Map.All')} sx={{ fontWeight: 'bold' }} />
                        </ListItemButton>
                        <ListItemButton onClick={() => { navigate(`/${i18n.language}/all-accommodation-listings?type=Pension`); setDrawerOpen(false); }}>
                          <ListItemText primary={t('Header.Pension')} />
                        </ListItemButton>
                        <ListItemButton onClick={() => { navigate(`/${i18n.language}/all-accommodation-listings?type=Hotel`); setDrawerOpen(false); }}>
                          <ListItemText primary={t('Header.Hotel')} />
                        </ListItemButton>
                        <ListItemButton onClick={() => { navigate(`/${i18n.language}/all-accommodation-listings?type=Guesthouse`); setDrawerOpen(false); }}>
                          <ListItemText primary={t('Header.Guesthouse')} />
                        </ListItemButton>
                        <ListItemButton onClick={() => { navigate(`/${i18n.language}/all-accommodation-listings?type=Barn`); setDrawerOpen(false); }}>
                          <ListItemText primary={t('Header.Barn')} />
                        </ListItemButton>
                        <ListItemButton onClick={() => { navigate(`/${i18n.language}/all-accommodation-listings?type=Camping`); setDrawerOpen(false); }}>
                          <ListItemText primary={t('Header.Camping')} />
                        </ListItemButton>
                      </List>
                    </Collapse>

                    <Divider sx={{ backgroundColor: 'rgba(255,255,255,0.1)' }} />

                    {/* Add Objects Collapsible */}
                    {GlobalState.userIsLogged && (
                      <>
                        <ListItemButton onClick={() => setMobileAddObjectsOpen(!mobileAddObjectsOpen)}>
                          <ListItemText primary={t('Header.Hozzaadas')} />
                          {mobileAddObjectsOpen ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={mobileAddObjectsOpen} timeout="auto" unmountOnExit>
                          <List component="div" disablePadding sx={{ pl: 4, bgcolor: 'rgba(0,0,0,0.1)' }}>
                            <ListItemButton onClick={() => { navigate(`/${i18n.language}/add-map-object`); setDrawerOpen(false); }}>
                              <ListItemText primary={t('SubMenu.MapObject') + " +"} />
                            </ListItemButton>
                            
                            <Divider sx={{ my: 1, backgroundColor: 'rgba(255,255,255,0.1)' }} />
                            <Typography variant="caption" sx={{ pl: 2, color: 'rgba(255,255,255,0.5)' }}>{t('SubMenu.MarketListing').toUpperCase()}</Typography>
                            <ListItemButton onClick={() => { navigate(`/${i18n.language}/addproperty`); setDrawerOpen(false); }}>
                              <ListItemText primary={t('SubMenu.Property') + " +"} />
                            </ListItemButton>
                            <ListItemButton onClick={() => { navigate(`/${i18n.language}/addcar`); setDrawerOpen(false); }}>
                              <ListItemText primary={t('SubMenu.Car') + " +"} />
                            </ListItemButton>
                            <ListItemButton onClick={() => { navigate(`/${i18n.language}/addaccommodation`); setDrawerOpen(false); }}>
                              <ListItemText primary={t('Header.Szallas') + " +"} />
                            </ListItemButton>
                            <ListItemButton onClick={() => { navigate(`/${i18n.language}/add-winter-sport`); setDrawerOpen(false); }}>
                              <ListItemText primary={t('SubMenu.WinterSports') + " +"} />
                            </ListItemButton>
                            <ListItemButton onClick={() => { navigate(`/${i18n.language}/add-summer-sport`); setDrawerOpen(false); }}>
                              <ListItemText primary={t('SubMenu.SummerSports') + " +"} />
                            </ListItemButton>
                            <ListItemButton onClick={() => { navigate(`/${i18n.language}/sajat-termeny-hozzaadasa`); setDrawerOpen(false); }}>
                              <ListItemText primary={t('SubMenu.OwnProduce') + " +"} />
                            </ListItemButton>
                            <ListItemButton component="a" href="https://szotar.szno.ro/map/occurence">
                              <ListItemText primary={t('SubMenu.SzeklerWord')} />
                            </ListItemButton>
                          </List>
                        </Collapse>
                      </>
                    )}
                  </List>
                </Box>
              </Drawer>

              <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem onClick={handleProfile}>{t('Header.Profile')}</MenuItem>
                <MenuItem onClick={handleAccount}>{t('Header.MyAccount')}</MenuItem>
                <MenuItem onClick={handleLogout}>{t('Header.Logout')}</MenuItem>
              </Menu>
            </>
          ) : (
            <>
              {/* Left nav buttons */}
              <Box sx={{ display: "flex", flex: 1, justifyContent: "flex-start", flexWrap: isTablet ? 'wrap' : 'nowrap' }}>
                <Button color="inherit" component={Link} to={`/${i18n.language}/news`} sx={{ mr: 0.5, px: 0.5, fontSize: isTablet ? '0.65rem' : '0.9rem', minWidth: 0 }}>{t('Header.Szemle')}</Button>
                <Button color="inherit" href="https://szotar.szno.ro/map" sx={{ mr: 0.5, px: 0.5, fontSize: isTablet ? '0.65rem' : '0.9rem', minWidth: 0 }}>{t('Header.SzekelySzotar')}</Button>
                <Button color="inherit" component={Link} to={`/${i18n.language}/kutfok`} sx={{ mr: 0.5, px: 0.5, fontSize: isTablet ? '0.65rem' : '0.9rem', minWidth: 0 }}>{t('Header.Kutfok')}</Button>
                <Button color="inherit" component={Link} to={`/${i18n.language}/academy`} sx={{ mr: 0.5, px: 0.5, fontSize: isTablet ? '0.65rem' : '0.9rem', minWidth: 0 }}>{t('Header.Akademia')}</Button>
                
                {/* Family Menu */}
                <Button 
                  color="inherit" 
                  onClick={handleFamilyClick} 
                  sx={{ mr: 0.5, px: 0.5, fontSize: isTablet ? '0.65rem' : '0.9rem', minWidth: 0 }}
                  endIcon={<ExpandMore sx={{ fontSize: '0.7rem' }} />}
                >
                  {t('Header.Family')}
                </Button>
                <Menu anchorEl={familyAnchorEl} open={familyOpen} onClose={handleFamilyClose}>
                  <MenuItem component={Link} to={`/${i18n.language}/csaladfaallitas`} onClick={handleFamilyClose} sx={{ fontSize: '0.9rem' }}>{t('Header.FamilyTree')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/family-manager`} onClick={handleFamilyClose} sx={{ fontSize: '0.9rem' }}>{t('Header.FamilyManager')}</MenuItem>
                </Menu>

                {/* Institutions */}
                <Button
                  color="inherit"
                  onClick={handleInstitutionsClick}
                  sx={{ mr: 0.5, px: 0.5, fontSize: isTablet ? '0.65rem' : '0.9rem', minWidth: 0 }}
                  endIcon={<ExpandMore sx={{ fontSize: '0.7rem' }} />}
                >
                  {t('Header.Institutions')}
                </Button>
                <Menu anchorEl={institutionsAnchorEl} open={institutionsOpen} onClose={handleInstitutionsClose}>
                  <MenuItem component={Link} to={`/${i18n.language}/institutions`} onClick={handleInstitutionsClose} sx={{ fontSize: '0.9rem' }}>{t('Header.Institutions')}</MenuItem>
                </Menu>
              </Box>

              {/* Logo */}
              <Box 
                sx={{ 
                  display: "flex", 
                  justifyContent: "center", 
                  alignItems: "center", 
                  mx: 1,
                  cursor: "pointer"
                }} 
                onClick={() => navigate(`/${i18n.language}`)}
              >
                <img src={logo} style={{ width: isTablet ? "3rem" : "4rem", marginTop: "0.2rem" }} alt="Logo" />
              </Box>

              {/* YouTube icon */}
              <Tooltip title="@Zandírhám">
                <Button color="inherit" component="a" href="https://www.youtube.com/@Zandírhám" target="_blank" rel="noopener noreferrer" sx={{ minWidth: 0, p: 0.5 }}>
                  <YouTubeIcon sx={{ fontSize: isTablet ? "1.5rem" : "2rem" }} />
                </Button>
              </Tooltip>

              {/* Site title */}
              <Box sx={{ ml: 0.5, display: "flex", alignItems: "center" }}>
                <Button color="inherit" component={Link} to={`/${i18n.language}`} sx={{ px: 0.5, minWidth: 0 }}>
                  <Typography 
                    variant={isTablet ? "subtitle1" : "h5"} 
                    sx={{ 
                      mr: isTablet ? 0.5 : 1, 
                      fontWeight: 'bold',
                      fontSize: isTablet ? '0.9rem' : '1.3rem',
                      whiteSpace: 'nowrap',
                      textTransform: 'uppercase'
                    }}
                  >
                    {isTablet ? 'SZNO' : t('Székely Nemzet Online')}
                  </Typography>
                </Button>
              </Box>

              {/* Map icon */}
              <Tooltip title={t('Header.InteractiveMap')}>
                <Button color="inherit" component={Link} to={`/${i18n.language}/terkep`} sx={{ minWidth: 0, p: 0.5 }}>
                  <MapIcon sx={{ fontSize: isTablet ? "1.5rem" : "2rem" }} />
                </Button>
              </Tooltip>

              <Typography variant="h6" sx={{ textAlign: "center", mb: 0.5 }}> ::: </Typography>

              {/* Right menus */}
              <Box sx={{ display: "flex", flex: 1, justifyContent: "flex-end", flexWrap: isTablet ? 'wrap' : 'nowrap' }}>

                {/* Sights */}
                <Button 
                  color="inherit" 
                  onClick={handleSightsClick} 
                  sx={{ mr: 0.3, px: 0.5, fontSize: isTablet ? '0.65rem' : '0.9rem', minWidth: 0 }}
                  endIcon={<ExpandMore sx={{ fontSize: '0.7rem' }} />}
                >
                  {t('Header.Latnivalok')}
                </Button>
                <Menu anchorEl={sightsAnchorEl} open={sightsOpen} onClose={handleSightsClose}>
                  <MenuItem component={Link} to={`/${i18n.language}/epitett-orokseg`} onClick={handleSightsClose} sx={{ fontSize: '0.9rem' }}>{t('Header.BuiltHeritage')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/rovasemlek`} onClick={handleSightsClose} sx={{ fontSize: '0.9rem' }}>{t('Header.RunicScripts')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/neprajzi`} onClick={handleSightsClose} sx={{ fontSize: '0.9rem' }}>{t('Header.Ethnographic')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/egyhazi`} onClick={handleSightsClose} sx={{ fontSize: '0.9rem' }}>{t('Header.Spiritual')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/geological-sights`} onClick={handleSightsClose} sx={{ fontSize: '0.9rem' }}>{t('Header.Geological')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/novenyvilag`} onClick={handleSightsClose} sx={{ fontSize: '0.9rem' }}>{t('Header.Botanical')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/gyalogtura`} onClick={handleSightsClose} sx={{ fontSize: '0.9rem' }}>{t('Header.Tracking')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/lovastura`} onClick={handleSightsClose} sx={{ fontSize: '0.9rem' }}>{t('Header.Equestrian')}</MenuItem>
                </Menu>

                {/* Companies & Masters */}
                <Button 
                  color="inherit" 
                  onClick={handleCompaniesMastersClick} 
                  sx={{ mr: 0.3, px: 0.5, fontSize: isTablet ? '0.65rem' : '0.9rem', minWidth: 0 }}
                  endIcon={<ExpandMore sx={{ fontSize: '0.7rem' }} />}
                >
                  {t('Header.CegekMesterek')}
                </Button>
                <Menu anchorEl={companiesMastersAnchorEl} open={companiesMastersOpen} onClose={handleCompaniesMastersClose}>
                  <MenuItem component={Link} to={`/${i18n.language}/cegek`} onClick={handleCompaniesMastersClose} sx={{ fontSize: '0.9rem' }}>{t('Header.Companies')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/mesterek`} onClick={handleCompaniesMastersClose} sx={{ fontSize: '0.9rem' }}>{t('Header.Masters')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/napszamosok`} onClick={handleCompaniesMastersClose} sx={{ fontSize: '0.9rem' }}>{t('Header.DayLabourers')}</MenuItem>
                </Menu>

                {/* Accommodation */}
                <Button 
                  color="inherit" 
                  onClick={handleAccommodationClick} 
                  sx={{ mr: 0.3, px: 0.5, fontSize: isTablet ? '0.65rem' : '0.9rem', minWidth: 0 }}
                  endIcon={<ExpandMore sx={{ fontSize: '0.7rem' }} />}
                >
                  {t('Header.Szallas')}
                </Button>
                <Menu anchorEl={accommodationAnchorEl} open={accommodationOpen} onClose={handleAccommodationClose}>
                  <MenuItem component={Link} to={`/${i18n.language}/szallasterkep`} onClick={handleAccommodationClose} sx={{ fontWeight: 'bold', fontSize: '0.9rem' }}>{t('Map.ShowOnMap', 'Megtekintés térképen')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/accommodation-market`} onClick={handleAccommodationClose} sx={{ fontSize: '0.9rem' }}>{t('Map.All')}</MenuItem>
                  <Divider />
                  <MenuItem component={Link} to={`/${i18n.language}/all-accommodation-listings?type=Pension`} onClick={handleAccommodationClose} sx={{ fontSize: '0.9rem' }}>{t('Header.Pension')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/all-accommodation-listings?type=Hotel`} onClick={handleAccommodationClose} sx={{ fontSize: '0.9rem' }}>{t('Header.Hotel')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/all-accommodation-listings?type=Guesthouse`} onClick={handleAccommodationClose} sx={{ fontSize: '0.9rem' }}>{t('Header.Guesthouse')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/all-accommodation-listings?type=Barn`} onClick={handleAccommodationClose} sx={{ fontSize: '0.9rem' }}>{t('Header.Barn')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/all-accommodation-listings?type=Camping`} onClick={handleAccommodationClose} sx={{ fontSize: '0.9rem' }}>{t('Header.Camping')}</MenuItem>
                </Menu>

                {/* Market */}
                <Button 
                  color="inherit" 
                  onClick={handleMarketMenuClick} 
                  sx={{ mr: 0.3, px: 0.5, fontSize: isTablet ? '0.65rem' : '0.9rem', minWidth: 0 }}
                  endIcon={<ExpandMore sx={{ fontSize: '0.7rem' }} />}
                >
                  {t('Header.Piacter')}
                </Button>
                <Menu 
                  anchorEl={marketMenuAnchorEl} 
                  open={marketMenuOpen} 
                  onClose={handleMarketMenuClose}
                >
                  <MenuItem component={Link} to={`/${i18n.language}/market`} onClick={handleMarketMenuClose} sx={{ fontWeight: 'bold', fontSize: '0.9rem' }}>{t('Map.All')}</MenuItem>
                  <Divider />
                  <MenuItem component={Link} to={`/${i18n.language}/sajat-termeny`} onClick={handleMarketMenuClose} sx={{ fontSize: '0.9rem' }}>{t('SubMenu.OwnProduce')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/sajattermeny-terkep`} onClick={handleMarketMenuClose} sx={{ fontSize: '0.8rem', pl: 4 }}>- {t('Map.ShowOnMap', 'Megtekintés térképen')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/termelok`} onClick={handleMarketMenuClose} sx={{ fontSize: '0.9rem' }}>{t('Market.Producers')}</MenuItem>
                  <Divider />
                  <MenuItem component={Link} to={`/${i18n.language}/all-property-listings`} onClick={handleMarketMenuClose} sx={{ fontSize: '0.9rem' }}>{t('SubMenu.Property')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/ingatlanterkep`} onClick={handleMarketMenuClose} sx={{ fontSize: '0.8rem', pl: 4 }}>- {t('Map.ShowOnMap', 'Megtekintés térképen')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/all-car-listings`} onClick={handleMarketMenuClose} sx={{ fontSize: '0.9rem' }}>{t('SubMenu.Car')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/autoterkep`} onClick={handleMarketMenuClose} sx={{ fontSize: '0.8rem', pl: 4 }}>- {t('Map.ShowOnMap', 'Megtekintés térképen')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/teli-sportfelszereles`} onClick={handleMarketMenuClose} sx={{ fontSize: '0.9rem' }}>{t('SubMenu.WinterSports')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/telisportfelszereles-terkep`} onClick={handleMarketMenuClose} sx={{ fontSize: '0.8rem', pl: 4 }}>- {t('Map.ShowOnMap', 'Megtekintés térképen')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/nyari-sportfelszereles`} onClick={handleMarketMenuClose} sx={{ fontSize: '0.9rem' }}>{t('SubMenu.SummerSports')}</MenuItem>
                  <MenuItem component={Link} to={`/${i18n.language}/nyarisportfelszereles-terkep`} onClick={handleMarketMenuClose} sx={{ fontSize: '0.8rem', pl: 4 }}>- {t('Map.ShowOnMap', 'Megtekintés térképen')}</MenuItem>
                </Menu>

                {/* Add Objects */}
                {GlobalState.userIsLogged && (
                  <>
                    <Tooltip title={t('Header.Hozzaadas')}>
                      <Button color="inherit" onClick={handleAddObjectsClick} sx={{ mr: 0.3, px: 0.5, minWidth: 0 }}>
                        <AddLocationIcon sx={{ fontSize: isTablet ? "1.5rem" : "2rem" }} />
                      </Button>
                    </Tooltip>
                    <Menu anchorEl={addObjectsAnchorEl} open={addObjectsOpen} onClose={handleAddObjectsClose}>
                        <MenuItem onClick={() => { handleAddObjectsClose(); navigate(`/${i18n.language}/add-map-object`); }} sx={{ fontSize: '0.9rem' }}>{t('SubMenu.MapObject')} +</MenuItem>
                      <MenuItem onClick={handleMarketClick} sx={{ fontSize: '0.9rem' }}>{t('SubMenu.MarketListing')} +</MenuItem>
                      <Menu anchorEl={marketAnchorEl} open={marketOpen} onClose={handleMarketClose}>
                        <MenuItem onClick={() => { handleMarketClose(); navigate(`/${i18n.language}/addproperty`); }} sx={{ fontSize: '0.9rem' }}>{t('SubMenu.PropertyListing')} +</MenuItem>
                        <MenuItem onClick={() => { handleMarketClose(); navigate(`/${i18n.language}/addcar`); }} sx={{ fontSize: '0.9rem' }}>{t('SubMenu.Car')} +</MenuItem>
                        <MenuItem onClick={() => { handleMarketClose(); navigate(`/${i18n.language}/addaccommodation`); }} sx={{ fontSize: '0.9rem' }}>{t('Header.Szallas')} +</MenuItem>
                        <MenuItem onClick={() => { handleMarketClose(); navigate(`/${i18n.language}/add-winter-sport`); }} sx={{ fontSize: '0.9rem' }}>{t('SubMenu.WinterSports')} +</MenuItem>
                        <MenuItem onClick={() => { handleMarketClose(); navigate(`/${i18n.language}/add-summer-sport`); }} sx={{ fontSize: '0.9rem' }}>{t('SubMenu.SummerSports')} +</MenuItem>
                        <MenuItem onClick={() => { handleMarketClose(); navigate(`/${i18n.language}/sajat-termeny-hozzaadasa`); }} sx={{ fontSize: '0.9rem' }}>{t('SubMenu.OwnProduce')} +</MenuItem>
                      </Menu>
                      <MenuItem component="a" href="https://szotar.szno.ro/map" sx={{ fontSize: '0.9rem' }}>{t('SubMenu.SubmitSzeklerWord')}</MenuItem>
                      <MenuItem onClick={() => { handleAddObjectsClose(); navigate(`/${i18n.language}/szekelyfoldi-esemenyek`, { state: { openAddDialog: true } }); }} sx={{ fontSize: '0.9rem' }}>{t('Events.AddEvent', 'Esemény hozzáadása')} +</MenuItem>
                    </Menu>
                  </>
                )}

                {/* User */}
                {GlobalState.userIsLogged ? (
                    <>
                      <Button color="inherit" onClick={handleClick} sx={{ mr: 1, px: 0.5, fontSize: isTablet ? '0.7rem' : '0.9rem', minWidth: 0 }}>
                        {GlobalState.userUsername}
                      </Button>
                      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                        <MenuItem component={Link} to={`/${i18n.language}/profile`} onClick={handleClose} sx={{ fontSize: '0.9rem' }}>{t('Header.Profile')}</MenuItem>
                        <MenuItem onClick={handleAccount} sx={{ fontSize: '0.9rem' }}>{t('Header.MyAccount')}</MenuItem>
                        <MenuItem onClick={handleLogout} sx={{ fontSize: '0.9rem' }}>{t('Header.Logout')}</MenuItem>
                      </Menu>
                    </>
                ) : (
                    <Button color="inherit" component={Link} to={`/${i18n.language}/login`} sx={{ mr: 1, px: 0.5, fontSize: isTablet ? '0.7rem' : '0.9rem', minWidth: 0 }}>{t('Header.Login')}</Button>
                )}
              </Box>
            </>
          )}

          <Snackbar
              open={openSnack}
              message={t('Header.LogoutSuccess')}
              autoHideDuration={2000}
              onClose={() => setOpenSnack(false)}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
          />
        </Toolbar>
      </ThemeProvider>
    </AppBar>
  );
}

export default Header;
